<mat-toolbar class="navbar-header" aria-label="Top Toolbar">
    @if (showMenu) {
        <button mat-icon-button aria-label="hamburger menu" (click)="toggle()">
            <mat-icon>menu</mat-icon>
        </button>
    }
    <a mat-button class="hoteler-button" routerLink="/" aria-label="Hoteler">
        <app-logo matButtonIcon />
        @if (showBrand) {
            <span>Hoteler</span>
        }
    </a>
    <div flexSpacer></div>
    <div class="actions-group">
        <app-toggle-button />
        <!-- <app-theme-picker /> -->
        @if (showGithubLogo) {
            <a
                mat-icon-button
                href="https://github.com/damingerdai/hoteler"
                aria-label="GitHub Repository"
            >
                <app-github matButtonIcon />
            </a>
        }
        @if (username) {
            <app-profile-menu
                [username]="username"
                [role]="role"
                (logout)="logout()"
            />
        }
    </div>
</mat-toolbar>
